import {ContactMail, Security, ToggleOn} from '@mui/icons-material';

export const listItems = [
  {title: 'personal info', link: '/myaccount', icon: ContactMail},
  {title: 'security', link: '/security', icon: Security},
  {title: 'preference', link: '/preference', icon: ToggleOn},
];
